import React from 'react';
import './entrepreneurship.css';

function C2wEntrepreneurship() {
  return (
    <div className="C2wEntrepreneurship_ctn">
      {/* Top Fold */}
      <div className="entrepreneurship-hero">
        {/* Left Column */}
        <div className="entrepreneurship-info">
          <div className="entrepreneurship-badge">
            <span className="badge-rocket-icon">🚀</span>
            <span>Entrepreneurship</span>
          </div>
          <h2 className="entrepreneurship-title">
            Have an Idea?<br />
            <span className="text-cyan">Let’s</span> <span className="text-white">Build It</span> <span className="text-pink">Together!</span>
          </h2>
          <p className="entrepreneurship-desc">
            If you have a startup idea or want to build your own business, core2web is here to support every step.
          </p>
          <button className="entrepreneurship-cta-btn">
            <svg className="btn-rocket-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4.5 16.5c-1.5 1.25-2.5 3.5-2.5 3.5s2.25-1 3.5-2.5M12 5l-8 8 2 2 8-8M9 8l7 7M20 4c1-1 3 0 3 0s1 2 0 3l-4 4-3-3 4-4z" />
            </svg>
            Start Your Journey Today
          </button>
        </div>

        {/* Right Column - Steps */}
        <div className="entrepreneurship-graphic-col">
          <img
            src="/assets/images/gallery/enter-bg.png"
            alt="Entrepreneurship Journey Steps"
            className="entrepreneurship-illustration-img"
          />
        </div>
      </div>

      {/* Bottom Success Card */}
      <div className="entrepreneurship-success-section">
        <h3 className="success-heading">Entrepreneurs we have supported-</h3>

        <div className="entrepreneur-card">
          <div className="entrepreneur-card-header">
            <div className="founder-profile-hld">
              <div className="founder-avatar-wrapper">
                <img src="/assets/images/gallery/Ranjeet.png" alt="Ranjeet Bhosale" />
              </div>
              <div className="founder-info-text">
                <h4 className="founder-name">Ranjeet Bhosale</h4>
                <span className="founder-title">Founder & CEO</span>
              </div>
            </div>

            <div className="company-logo-hld">
              <img src="/assets/images/gallery/subscription-logo.png" alt="THE SUBSCRIPTION Logo" className="logo-icon-img" />
            </div>
          </div>

          <p className="entrepreneur-testimonial">
            "Hi, I’m Ranjeet Bhosale, Founder & CEO. As a student myself, I saw how difficult it is to manage multiple digital subscriptions — from streaming to productivity tools — especially when you’re on a budget. Most people either overspend or lose track of what they’re paying for. That’s why we created TheSubscription to help people manage subscriptions, all from one place. Our goal is to build a trust-based, community-powered platform that makes subscription management smarter and more affordable."
          </p>
        </div>
      </div>
    </div>
  );
}

export default C2wEntrepreneurship;
